import { createSlice } from '@reduxjs/toolkit';
import { DealEnquiresReducerStateType } from './types';

const initialState = {
  offset: 0,
  limit: 25,
  search: '',
  order: 'desc',
  sortBy: 'dateOfEnquiry',
  clearPage: true,
  totalCount: 0,
  deals: '',
  date: null,
  status: 'all'
} as DealEnquiresReducerStateType;

export const dealEnquiresListStateReducer = createSlice({
  name: 'dealEnquiresListStateReducer',
  initialState,
  reducers: {
    updateDealEnquiresListStateReducerValues: (state, { payload }) => ({
      ...state,
      ...payload
    }),
    resetDealEnquiresListStateReducerValues: state => ({
      ...state,
      search: '',
      date: null,
      deals: '',
      status: 'all'
    })
  }
});

export const {
  updateDealEnquiresListStateReducerValues,
  resetDealEnquiresListStateReducerValues
} = dealEnquiresListStateReducer.actions;

export default dealEnquiresListStateReducer.reducer;
